export default __webpack_public_path__ + "static/media/Braves.c294b06e.png";